module.exports = __webpack_public_path__ + "static/img/saimenInstallForWin_pic6.3680b28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/saimenInstallForWin/saimenInstallForWin_pic6.png
// module id = 589
// module chunks = 1